export default "__VITE_ASSET__0riuPkiy__"